<template>
  <div>
    <van-steps direction="vertical"  active-color="#FC6E09" :active="active">
        <van-step v-for="(item,index) in stepList" :key="index">
          <p>{{item.createTime}}  {{item.username}}</p>
          <p>{{item.digest}}</p>
        </van-step>
      </van-steps>
  </div>
</template>

<script>
export default {
  props:{
    stepList: {
      type: Array
    }
  },
data(){
    return{
        active:0,
      // stepList:[
      //     {//步骤条数据
      //       time:'2022-04-24 14:23:34',
      //       stage:'查看产品“{产品名称}”',
      //     },
      //     {//步骤条数据
      //       time:'2022-05-14 14:23:34',
      //       stage:'查看产品“{产品名称}”',
      //     },
      //     {//步骤条数据
      //       time:'2022-05-23 14:23:34',
      //       stage:'查看产品“{产品名称}”',
      //     },

      // ],
    }
}
}
</script>

<style lang="less" scoped>


</style>